@if (!showInitials) {
  <img
    [src]="avatarUrl"
    [width]="size"
    [height]="size"
    class="adf-avatar adf-avatar--img"
    [alt]="name ?? ''"
    (error)="onAvatarError()"
  />
} @else {
  <div class="adf-avatar" [style.width.px]="size" [style.height.px]="size" [style.font-size.px]="size * 0.375">
    <span>
      {{ getInitials() }}
    </span>
  </div>
}
